const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

export const getReceivingTimeTimestamp = (item) => {
  const raw =
    item?.requestReceivingTime ||
    item?.receivedAt ||
    item?.requestedAt ||
    item?.submittedAt ||
    item?.createdAt ||
    item?.nursingRequest?.requestReceivingTime ||
    item?.nursingRequest?.createdAt;

  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }

  const id = item?._id || item?.nursingRequest?._id;
  if (OBJECT_ID_PATTERN.test(id || "")) {
    return parseInt(id.slice(0, 8), 16) * 1000;
  }

  return 0;
};

export const sortByReceivingTimeDesc = (items = []) =>
  [...items].sort((a, b) => getReceivingTimeTimestamp(b) - getReceivingTimeTimestamp(a));

export const getStartTimeTimestamp = (item) => {
  const raw = item?.startTime;
  if (raw) {
    // startTime may be an ISO string, or a pre-formatted display string like "23 Jun 2026 at 10:00 AM"
    let timestamp = new Date(raw).getTime();
    if (Number.isNaN(timestamp) && typeof raw === "string") {
      timestamp = new Date(raw.replace(" at ", " ")).getTime();
    }
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return getReceivingTimeTimestamp(item);
};

export const sortByStartTimeAsc = (items = []) =>
  [...items].sort((a, b) => getStartTimeTimestamp(a) - getStartTimeTimestamp(b));

export const sortByStartTimeDesc = (items = []) =>
  [...items].sort((a, b) => getStartTimeTimestamp(b) - getStartTimeTimestamp(a));

export const getQuotationSentTimeTimestamp = (item) => {
  const raw = item?.updatedAt || item?.createdAt;
  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return getReceivingTimeTimestamp(item);
};

export const sortByQuotationSentTimeDesc = (items = []) =>
  [...items].sort((a, b) => getQuotationSentTimeTimestamp(b) - getQuotationSentTimeTimestamp(a));

export const getPaymentMadeTimeTimestamp = (item) => {
  const raw = item?.updatedAt || item?.createdAt;
  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return getReceivingTimeTimestamp(item);
};

export const sortByPaymentMadeTimeDesc = (items = []) =>
  [...items].sort((a, b) => getPaymentMadeTimeTimestamp(b) - getPaymentMadeTimeTimestamp(a));

export const getScheduledTimeTimestamp = (item) => {
  const raw = item?.scheduledAt || item?.startTime || item?.createdAt;
  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return 0;
};

export const sortByScheduledTimeDesc = (items = []) =>
  [...items].sort((a, b) => getScheduledTimeTimestamp(b) - getScheduledTimeTimestamp(a));

export const getCheckoutTimeTimestamp = (item) => {
  const raw = item?.checkOutTime || item?.endTime || item?.startTime || item?.createdAt;
  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return 0;
};

export const sortByCheckoutTimeDesc = (items = []) =>
  [...items].sort((a, b) => getCheckoutTimeTimestamp(b) - getCheckoutTimeTimestamp(a));

export const getCancelledTimeTimestamp = (item) => {
  const raw = item?.cancelledAt || item?.updatedAt || item?.createdAt;
  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }
  return getReceivingTimeTimestamp(item);
};

export const sortByCancelledTimeDesc = (items = []) =>
  [...items].sort((a, b) => getCancelledTimeTimestamp(b) - getCancelledTimeTimestamp(a));


const getPatientFullName = (patient) => {
  if (!patient) return "";
  if (typeof patient.fullName === "string") return patient.fullName;
  if (patient.fullName && typeof patient.fullName === "object") {
    return patient.fullName.en || patient.fullName.vi || Object.values(patient.fullName)[0] || "";
  }
  return `${patient.firstName || ""} ${patient.lastName || ""}`.trim();
};

// Patient Full Name + HN Number search, consistent across every Manage Request tab.
// Also matches request ID (harmless superset — doesn't narrow results away from name/HN matches).
export const matchesRequestSearch = (item, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const reqId = (item.nursingRequestID || item._id || "").toLowerCase();
  const hn = (item.hnNumber || item.hn || item.patient?.hnNumber || item.relativeInfo?.hnNumber || "").toLowerCase();
  const rel = item.relativeInfo;
  const relName = rel ? `${rel.firstName || ""} ${rel.lastName || ""}`.toLowerCase() : "";
  const patName = getPatientFullName(item.patient).toLowerCase();

  return reqId.includes(q) || hn.includes(q) || relName.includes(q) || patName.includes(q);
};
